import React, { forwardRef, ComponentProps } from 'react';

import theme from '@adsk/alloy-react-theme';

import Icon, { IconWithRender, generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
import { IconVariations } from '../useIconVariation';

const draw16px =
  'M14.743,11a.676.676,0,0,1-.22.53l-2.91,2.91a.742.742,0,0,1-.53.22.725.725,0,0,1-.53-.22.754.754,0,0,1,0-1.06l1.63-1.63H5.993a.75.75,0,0,1,0-1.5h6.19l-1.63-1.64a.75.75,0,0,1,1.06-1.06l2.91,2.92a.676.676,0,0,1,.22.53Zm-.088.358,0,.006Zm-.122.172a.865.865,0,0,0,.118-.166.781.781,0,0,1-.128.166Zm.2-.38a.748.748,0,0,1-.078.208A.693.693,0,0,0,14.733,11.152Zm0-.3a.7.7,0,0,0-.078-.207A.742.742,0,0,1,14.733,10.852Zm-.2-.38h-.01a.813.813,0,0,1,.128.167A.9.9,0,0,0,14.533,10.472Zm.122.173,0-.006ZM9.993,4.252H3.813l1.64-1.64a.75.75,0,1,0-1.06-1.06l-2.92,2.92a.776.776,0,0,0-.16.24.731.731,0,0,0,0,.58.776.776,0,0,0,.16.24l2.92,2.91a.725.725,0,0,0,.53.22.742.742,0,0,0,.53-.22.754.754,0,0,0,0-1.06l-1.64-1.63h6.18a.75.75,0,0,0,0-1.5Z';
const draw24px =
  'M20.8,16.051a.684.684,0,0,1-.06.29.776.776,0,0,1-.16.24l-2.92,2.92a.749.749,0,0,1-.53.22.786.786,0,0,1-.53-.22.754.754,0,0,1,0-1.06l1.64-1.64h-9.5a.75.75,0,0,1,0-1.5h9.5l-1.64-1.63a.754.754,0,0,1,0-1.06.737.737,0,0,1,1.06,0l2.92,2.91a.776.776,0,0,1,.16.24A.717.717,0,0,1,20.8,16.051ZM15.263,7.3h-9.4L7.5,5.671a.754.754,0,0,0,0-1.06.737.737,0,0,0-1.06,0l-2.92,2.91a.776.776,0,0,0-.16.24.717.717,0,0,0-.06.29.684.684,0,0,0,.06.29.776.776,0,0,0,.16.24l2.92,2.92a.749.749,0,0,0,.53.22.786.786,0,0,0,.53-.22.754.754,0,0,0,0-1.06L5.863,8.8h9.4a.75.75,0,0,0,0-1.5Z';

const icons: IconVariations = {
  _16: {
    d: draw16px,
    viewBox: VIEWBOXES._16,
    fill: theme.tokens.colors.icon.inactive.value,
  },
  _24: {
    d: draw24px,
    viewBox: VIEWBOXES._24,
    fill: theme.tokens.colors.icon.inactive.value,
  },
};

const ArrowsNoneIcon = forwardRef<SVGSVGElement, ComponentProps<typeof Icon>>(
  generateRenderedIcon(icons, 'arrowsNone'),
) as IconWithRender;

ArrowsNoneIcon.displayName = 'ArrowsNoneIcon';
ArrowsNoneIcon.propTypes = Icon.propTypes;
ArrowsNoneIcon.renderIcon = (props) => <ArrowsNoneIcon {...props} />;
export default ArrowsNoneIcon;
